/* eslint-disable */
// WARNING: DO NOT EDIT. This file is automatically generated by AWS Amplify. It will be overwritten.

const awsmobile = {
    "aws_project_region": "eu-west-1",
    "aws_cognito_identity_pool_id": "eu-west-1:4c6b6331-71ea-4ead-96de-de20eaab4fca",
    "aws_cognito_region": "eu-west-1",
    "aws_user_pools_id": "eu-west-1_ifTsEfVu1",
    "aws_user_pools_web_client_id": "opb7a5olbrh023kq3lc1qlj4a",
    "oauth": {}
};


export default awsmobile;
